import React from 'react';
import { StatusConfig } from '../types/ShopData';

const StatusCircle = ({ status, statusTexts }) => {
  const config = StatusConfig[status] || StatusConfig.closed;
  
  const getBackgroundColor = () => {
    switch (status) {
      case 'green':
        return 'bg-green-500';
      case 'yellow':
        return 'bg-yellow-400';
      case 'orange':
        return 'bg-orange-400';
      case 'closed':
        return 'bg-gray-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusMessage = () => {
    if (!statusTexts) return config.text;
    switch (status) {
      case 'green':
        return statusTexts.green;
      case 'yellow':
        return statusTexts.yellow;
      case 'orange':
        return statusTexts.orange;
      case 'closed':
        return statusTexts.closed;
      default:
        return statusTexts.closed || config.text;
    }
  };
  
  return (
    <div className={`${getBackgroundColor()} rounded-xl p-6 max-w-lg mx-auto shadow-lg text-center`}>
      <h2 className="text-xl font-bold text-white mb-1">{config.text}</h2>
      <p className="text-base text-white opacity-90">{getStatusMessage()}</p>
    </div>
  );
};

export default StatusCircle;